import React from 'react';

function SvgIcPqrButton2(props) {
  return (
    <svg
      id="ic_pqr_button_svg"
      width={props.size || 90}
      height={props.size || 90}
      viewBox="0 0 90 90"
      xmlSpace="preserve"
      fill={'#fff'}
      {...props}
    >
      <defs>
        <linearGradient
          id="ic_pqr_button_2_svg__a"
          x2={1}
          y2={1.031}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#a54cf3" />
          <stop offset={1} stopColor="#3c41db" />
        </linearGradient>
      </defs>
      <g data-name="Grupo 598">
        <path
          d="M3.624 0h82.752A3.624 3.624 0 0190 3.624v82.752A3.624 3.624 0 0186.376 90H3.624A3.624 3.624 0 010 86.376V3.624A3.624 3.624 0 013.624 0z"
          fill="url(#ic_pqr_button_2_svg__a)"
        />
        <g data-name="Grupo 597">
          <g data-name="Grupo 596">
            <path
              data-name="Trazado 612"
              d="M58.19 55.101l-4.59-1.532-1.647-3.294a10.57 10.57 0 002.861-5.592l.205-1.231h1.756a2.9 2.9 0 002.9-2.9v-6.08a14.477 14.477 0 10-28.953 0v6.08a2.9 2.9 0 001.93 2.729v1.131a2.9 2.9 0 002.9 2.9h.848a10.47 10.47 0 001.619 2.507c.137.157.279.309.425.458l-1.646 3.292-4.598 1.532c-5.329 1.776-9.2 7.391-9.2 13.348a.965.965 0 00.965.965h42.464a.965.965 0 00.965-.965c.001-5.957-3.871-11.572-9.204-13.348zm-.446-14.54a.966.966 0 01-.965.965h-1.473c.245-1.9.409-3.922.475-5.914 0-.056 0-.111.005-.166h1.958zm-24.127.965a.966.966 0 01-.965-.965v-5.118h1.958q0 .151.01.3v.01c.068 1.937.229 3.907.469 5.765h-1.473zm1.93 3.86a.966.966 0 01-.965-.965v-.965h.791l.205 1.231c.039.234.087.467.143.7zm-.963-11.871h-1.9a12.547 12.547 0 0125.019 0h-1.891a9.775 9.775 0 00-9.751-9.654h-1.727a9.775 9.775 0 00-9.751 9.651zm9.751-7.721h1.728a7.848 7.848 0 017.822 7.857c0 .3 0 .568-.008.809v.009l-1.207-.172a15.508 15.508 0 01-8.719-4.36.965.965 0 00-.682-.283 8.731 8.731 0 00-6.713 3.176 7.845 7.845 0 017.778-7.038zm-6.613 19.589a55.164 55.164 0 01-1.158-9.367l1.3-1.732a6.793 6.793 0 015.023-2.691 17.456 17.456 0 009.513 4.608l1.421.2a59.496 59.496 0 01-.567 5.9c-.088.6-.158.983-.336 2.058a8.2 8.2 0 01-5.818 6.593 7.593 7.593 0 01-8.524-3.646h1.967a2.9 2.9 0 002.729 1.93H45.2a2.9 2.9 0 100-5.791h-1.93a2.9 2.9 0 00-2.731 1.93zm5.464 7.529a9.68 9.68 0 003.59.081l-1.706 1.808zm.557 3.287l-3.061 3.237a36.771 36.771 0 01-2.161-5.011l1.15-2.3zm6.817-4.4l1.313 2.626a36.762 36.762 0 01-2.161 5.012l-3.276-3.276zm-8.26-5.451a.965.965 0 01.965-.965H45.2a.965.965 0 110 1.93h-1.93a.966.966 0 01-.97-.965zM24.969 67.484a12.2 12.2 0 017.846-10.555l4.062-1.354a38.688 38.688 0 002.747 5.959l.005.01a38.7 38.7 0 002.642 4.034l1.187 1.906zm20.228-.86l-1.309-2.1q-.022-.035-.047-.069a36.8 36.8 0 01-2.174-3.254l3.442-3.64 3.627 3.627a36.757 36.757 0 01-2.182 3.262c-.048.066.019-.033-1.354 2.174zm1.738.86l1.187-1.906a38.684 38.684 0 002.66-4.066l.014-.026a38.657 38.657 0 002.718-5.908l4.062 1.354a12.2 12.2 0 017.847 10.555z"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgIcPqrButton2;
